import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, TemplateRef, ViewChild, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngxs/store';
import { DialogState, DialogStateModel } from '@app/_store';
import { Observable, Subject } from 'rxjs';
import { ConfirmDialogService } from '@app/_services';
import { tap, takeUntil } from 'rxjs/operators';
import { NgTemplateOutlet, NgIf, NgClass, AsyncPipe } from '@angular/common';
import { AutofocusDirective } from '../../directives/autofocus.directive';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf, NgClass, AutofocusDirective, AsyncPipe],
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject<boolean>();
  current$: Observable<DialogStateModel> = inject(Store).select(DialogState.getCurrent);

  @ViewChild('content')
  content: TemplateRef<NgTemplateOutlet>;

  modalRef: NgbModalRef;

  isExecuting = false;

  constructor(
    private store: Store,
    private modalService: NgbModal,
    private confirmDialogService: ConfirmDialogService
  ) {}

  ngOnInit() {
    this.confirmDialogService
      .getMessage()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(message => {
        this.isExecuting = false;
        if (message) {
          this.modalRef = this.modalService.open(this.content, {
            backdrop: 'static',
            keyboard: this.store.selectSnapshot(DialogState.getCurrent).onCancel !== undefined,
          });
        } else {
          this.modalRef.close();
        }
      });
  }

  exec(callback: () => Observable<void>): void {
    if (callback) {
      this.isExecuting = true;
      callback()
        .pipe(
          takeUntil(this.componentDestroyed$),
          tap(() => {
            this.modalRef.close();
            this.isExecuting = false;
          })
        )
        .subscribe();
    } else {
      this.modalRef.close();
    }
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
